import React, { FC } from 'react';
import classNames from 'classnames';

import { subtitlesPosition } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Subtitles/Subtitles.types';

import {
    useSubtitlesSettings,
    useSubtitlesSettingsSetters,
} from '../../../hooks/skin/use-subtitles';

import styles from './styles.module.css';

interface Props {
    isControlsVisible: boolean;
    className?: string;
}

export const SubtitlesPortalRoot: FC<Props> = ({ isControlsVisible, className }) => {
    const { position } = useSubtitlesSettings();
    const { setSubtitlesContainer } = useSubtitlesSettingsSetters();

    return (
        <div
            ref={setSubtitlesContainer}
            className={classNames(className, styles.root, {
                [styles.top]: position === subtitlesPosition.TOP,
                [styles.bottom]: position === subtitlesPosition.BOTTOM,
                [styles.withControls]: isControlsVisible,
            })}
        />
    );
};
